<script>
import ModuleTitle from '../common/ModuleTitle.vue'
import AudioPlayer from 'comp/common/AudioPlayer'
import AudioPlayer61 from 'comp/common/AudioPlayer/AudioPlayer61'
import AudioPlayer66 from 'comp/common/AudioPlayer/AudioPlayer66'

import { getSubPage } from '@/api/pageData'

export default {
  name: 'DialogId12',
  components: { ModuleTitle, AudioPlayer, AudioPlayer61, AudioPlayer66 },
  props: {
    currentModule: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path,
      pageData: [],
      previewShow: false
    }
  },
  created() {
    this.initPageData()
  },
  methods: {
    handleAudioClick(idx) {
      this.pageData.forEach((item, index) => {
        index === idx
          ? item.isplaying = !item.isplaying
          : item.isplaying ? item.isplaying = false : ''
      })
    },

    initPageData() {
      const params = {
        titleid: Number(this.currentModule.titleid),
        title: this.currentModule.title,
        subtitle: '',
        userid: localStorage.getItem('screenUserid') || 0,
        village: localStorage.getItem('currentCommunity') || ''
      }
      getSubPage(params).then(res => {
        if (res.code === 0) {
          this.pageData = res.msg[0].list
          this.pageData.forEach(item => this.$set(item, 'isplaying', false))
        }
      })
    }
  }
}
</script>

<template>
  <div class="dialog-id-12">
    <div class="title-container">
      <module-title :title="currentModule.title" margin-bottom="40" />
    </div>
    <div v-if="currentModule.id == 15" class="group-container">
      <audio-player
        v-for="(v, i) in pageData"
        :key="`modules-29-${v.id}`"
        ref="audioGroup"
        :audiourl="v.typename"
        :title="v.headline"
        :publisher="v.name"
        :idx="i"
        :isplaying="v.isplaying"
        @handleAudioClick="handleAudioClick"
      />
    </div>
    <div v-if="currentModule.id == 61" class="group-container" :class="{'group-container61': currentModule.id == 61}">
      <audio-player61
        v-for="(v, i) in pageData"
        :key="`modules-29-${v.id}`"
        ref="audioGroup"
        :audiourl="v.typename"
        :title="v.headline"
        :publisher="v.name"
        :idx="i"
        :isplaying="v.isplaying"
        @handleAudioClick="handleAudioClick"
      />
    </div>
    <div v-if="currentModule.id == 66" class="group-container">
      <audio-player66
        v-for="(v, i) in pageData"
        :key="`modules-29-${v.id}`"
        ref="audioGroup"
        :audiourl="v.typename"
        :title="v.headline"
        :publisher="v.name"
        :idx="i"
        :isplaying="v.isplaying"
        @handleAudioClick="handleAudioClick"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
// 1330
.dialog-id-12 {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.title-container {
  width: 100%;
}
.group-container {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  width: 940px;
  padding: 30px 10px;
  gap: 20px;
  height: 610px;
  overflow-y: scroll;
  &::-webkit-scrollbar { // chrome/safari
    display: none;
  }
  scrollbar-width: none; // firefox
  -ms-overflow-style: none; // IE10+
}
.group-container61 {
  column-gap: 40px;
  row-gap: 20px;
}
</style>
